import { __read } from 'tslib';
import React__default from 'react';
import classNames from 'classnames';
import { useDebounce } from 'use-debounce';
import { NvInputSearch, NvSelect } from '@invitae/ids-react';
import { useTextCopy } from '../../hooks/useTextCopy.esm.js';
import styles from './SearchBar.module.esm.js';

var SearchBar = function (_a) {
    var onSearch = _a.onSearch, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, filters = _a.filters, searchResultsCount = _a.searchResultsCount, classNames$1 = _a.classNames, isLoading = _a.isLoading;
    var _c = __read(React__default.useState(defaultValue), 2), searchTerm = _c[0], setSearchTerm = _c[1]; // manages the search input value
    var _d = __read(React__default.useState(''), 2), lastSearchedTerm = _d[0], setLastSearchedTerm = _d[1]; // saves the last completed search for the "show results" text
    var _e = __read(React__default.useState(false), 2), showResults = _e[0], toggleShowResults = _e[1]; // determines whether or not we show the "show results" text
    var _f = __read(useDebounce(searchTerm, 300), 1), debouncedSearchQuery = _f[0];
    var getText = useTextCopy({
        lastSearchedTerm: lastSearchedTerm,
        searchResultsCount: "".concat(searchResultsCount),
    }).getText;
    var executeSearch = React__default.useCallback(function () {
        var searchQuery = debouncedSearchQuery;
        setLastSearchedTerm(searchQuery);
        if (onSearch) {
            onSearch(searchQuery);
        }
        toggleShowResults(true);
    }, [onSearch, debouncedSearchQuery]);
    React__default.useEffect(function () {
        executeSearch();
    }, [debouncedSearchQuery, executeSearch]);
    var handleSearchInputChange = React__default.useCallback(function (value) {
        setSearchTerm(value);
    }, []);
    // prevent the form from reloading the page on enter, since we are executing the search on each change to debouncedSearchQuery
    var preventFormSubmission = function (e) { return e.preventDefault(); };
    var resultsText = React__default.useMemo(function () {
        if (isLoading)
            return getText('searchResultsLoading');
        if (!searchResultsCount || !debouncedSearchQuery || searchResultsCount === '0')
            return null;
        return debouncedSearchQuery && searchResultsCount !== undefined
            ? getText('showResultWithTerm')
            : getText('showResult');
    }, [debouncedSearchQuery, isLoading, searchResultsCount, getText]);
    var resetSearch = function () {
        setSearchTerm('');
        toggleShowResults(false);
        onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
    };
    return (React__default.createElement("div", { className: classNames(styles.wrapper, classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.wrapper) },
        React__default.createElement("form", { className: classNames(styles.searchAndFilter, classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.form), onSubmit: preventFormSubmission, role: "search" },
            React__default.createElement(NvInputSearch, { buttonResetAriaLabel: getText('buttonResetAriaLabel'), buttonSubmitAriaLabel: getText('buttonSubmitAriaLabel'), classNames: classNames(styles.searchForm, classNames$1 === null || classNames$1 === void 0 ? void 0 : classNames$1.searchComponent), "data-cy": "search-bar", defaultValue: defaultValue, label: "Search", onChangeInput: handleSearchInputChange, onClearInput: resetSearch, onSearch: executeSearch, placeholder: getText('placeholder'), showPrefixElement: true }),
            React__default.createElement("div", { className: classNames(styles.results, styles.mobileResults) }, showResults && resultsText),
            React__default.createElement("div", { className: styles.filterGroup }, filters.map(function (filter) { return (React__default.createElement("div", { className: classNames(styles.filterWrapper), "data-testid": "filter-wrapper", key: filter.label, style: filter.width ? { minWidth: filter.width } : undefined },
                React__default.createElement(NvSelect, { "data-testid": "filter", label: filter.label, name: filter.label, onChange: function (option) { return filter.changeHandler(option === null || option === void 0 ? void 0 : option.value); }, options: filter.options, value: filter.options.find(function (option) { return option.value === filter.selectedValue; }) }))); }))),
        React__default.createElement("div", { className: classNames(styles.results, styles.nonMobileResults) }, showResults && resultsText)));
};

export { SearchBar as default };
//# sourceMappingURL=SearchBar.esm.js.map
